import React from 'react';
import PropTypes from 'prop-types'


export default class SearchSelect  extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
        showValue:true,
        valoareSelectata:'',
        search:''
}
    }

     componentDidMount(){
    this.initState()
    }

initState=()=>{
    let idx = this.props.listaElemente.findIndex(i => i.id === this.props.selectedValue)

    if(idx !== -1){
        this.setState({valoareSelectata:this.props.listaElemente[idx].valoare})
    }else{
        this.setState({valoareSelectata:this.props.selectInitialValue})
    }

}

elClick = (e) =>{
    this.setState({showValue:true,
        search:'',
        valoareSelectata:e.valoare},()=>{
        this.props.toServer(e)
    })
}

filterElemente = () =>{
    let elemente = [...this.props.listaElemente]

    // console.log('elemente :', elemente);

    let elementeFilter = elemente.filter(i => i.valoare.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 )

    // console.log('elementeFilter :', elementeFilter);
    return elementeFilter.map((e,idx)=>{
        return(
            <li style={{cursor:'pointer', 
                        marginBottom:5,
                        borderBottom:'1px solid #dadada'}} onClick={()=>{this.elClick(e)}} key={idx}>
                {e.valoare}
            </li>
        )
    })
}

showList=()=>{
   

    this.setState({showValue:false},()=>{
        let searchInp = document.getElementById('searchSelect')
        searchInp.focus()
    })
}

     render() { 
       return (
          <div style={{ position:'relative',minWidth:'fit-content',  width:this.props.width ? this.props.width  : 100, }}>
           
            <div style={{cursor:'pointer', 
                        display:this.state.showValue ? 'block' : 'none',
                        height:'fit-content', 
                        padding:8, 
                        border:'1px solid gray', 
                        marginTop:20, 
                        marginLeft:10,}} onClick={this.showList}>
                <span style={{verticalAlign:'super'}}>{this.state.valoareSelectata}</span>
                <i className='material-icons'
                
                >keyboard_arrow_down</i>
            </div>
            <div style={{display:this.state.showValue ? 'none' : 'block', marginTop:10, marginLeft:10, position:'relative'}}>
           
                <i
                onClick={()=>{this.setState({showValue:true})}}
                style={{position:'absolute',
                right:0,
                top:-8,
                border:'1px solid #dcdada',
                backgroundColor:'red',
                color:'white',
                borderRadius:20,
                fontSize:21,
                cursor:'pointer'
            }}
                className='material-icons'>clear</i>
           
                <label htmlFor='searchSelect'>
                <span style={{display:'block', fontSize:13, textAlign:'left'}}>{this.props.inputLabel}</span>
                    <input autoFocus style={{fontSize:16}} id='searchSelect' type='text' value={this.state.search} onChange={(ev)=>{this.setState({search:ev.target.value})}} />
           
                </label>

            </div>
                <ul style={{display:this.state.showValue ? 'none' : 'block',
                             position:'absolute', 
                             listStyleType:'none', 
                             maxHeight:100, 
                             overflow:'scroll',
                             backgroundColor:'white',
                             border:'0.5px solid #dadada',
                             padding:'10px',
                             right:0,
                             left:0,
                             margin:'10px auto',
                             width:'fit-content'
                             }}>
                   { this.filterElemente()}
                </ul>
         </div>
        );
       }
}//end class


SearchSelect.propType = {
    listaElemente:PropTypes.array, // lista elemente
    selectedValue:PropTypes.number, // id-ul elementului selectat sau venit din baza
    selectInitialValue:PropTypes.string, // label initial daca id-ul nu se regaseste in lista de elemente
    toServer:PropTypes.func, // functia din parent care face ceva cu elementul selectat
    inputLabel:PropTypes.string, // label pentru inputul de search
    width:PropTypes.number, 
}